export default {
	methods: {
		showToast(message, title, type, timer, i18n = true) {
			title = !title ? '': i18n && this.$te(title) ? this.$t(title) : title;
			message = !message  ? '': i18n && this.$te(message) ? this.$t(message) : message;
			this.$store.dispatch('toasts/showToast', { title, message, type, timer });
		},
	},
};
